import { render, staticRenderFns } from "./SelectOptionalGoodsCard.vue?vue&type=template&id=53e1d2de&scoped=true"
import script from "./SelectOptionalGoodsCard.vue?vue&type=script&lang=js"
export * from "./SelectOptionalGoodsCard.vue?vue&type=script&lang=js"
import style0 from "./SelectOptionalGoodsCard.vue?vue&type=style&index=0&id=53e1d2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e1d2de",
  null
  
)

export default component.exports